import './App.css'

function App() {
  return (
    <div className="app">
      {/* Hero Section */}
      <section className="hero">
        <nav className="navbar">
          <div className="logo">
            <a href="/">HEYBUB</a>
          </div>
          <div className="nav-links">
            <a href="#features">MUSIC</a>
            <a href="#about">ABOUT</a>
            <a href="#contact">CONTACT</a>
          </div>
        </nav>
        <div className="hero-content">
          <h1 className="ritchie-title">HEYBUB</h1>
          <p className="ritchie-subtitle">IT'S TIM!</p>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <h2 className="ritchie-heading">PROJECTS</h2>
        <div className="features-grid">
          <a href="/creatures" target="_blank" rel="noopener noreferrer" className="feature-card">
            <h3>CREATURES FROM MARS</h3>
          </a>
          <div className="feature-card">
            <h3>ACOUSTIC STUFF</h3>
          </div>
          <div className="feature-card">
            <h3>OTHER THINGS</h3>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <h2 className="ritchie-heading">ABOUT</h2>
        <div className="about-content">
          <p>Making music and other things since forever.</p>
          <p>Sometimes with creatures from Mars.</p>
          <p>Sometimes with a guitar.</p>
          <p>Always with a smile.</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>THE CREATURES ARE COMING...</h4>
            <p>and they want to steal your children</p>
          </div>
          <div className="footer-section">
            <h4>FIND US</h4>
            <p>Email: tim@heybubitstim.com</p>
            <p>Phone: (555) HEY-BUB</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 HEYBUB. ALL RIGHTS RESERVED.</p>
        </div>
      </footer>
    </div>
  )
}

export default App
